var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F4080A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#F4080A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2701 11.2701C11.6303 10.91 12.2143 10.91 12.5745 11.2701L17.5 16.1957L22.4255 11.2701C22.758 10.9377 23.2811 10.9121 23.643 11.1934L23.7299 11.2701C24.09 11.6303 24.09 12.2143 23.7299 12.5745L18.8043 17.5L23.7299 22.4255C24.0623 22.758 24.0879 23.2811 23.8066 23.643L23.7299 23.7299C23.3697 24.09 22.7857 24.09 22.4255 23.7299L17.5 18.8043L12.5745 23.7299C12.242 24.0623 11.7189 24.0879 11.357 23.8066L11.2701 23.7299C10.91 23.3697 10.91 22.7857 11.2701 22.4255L16.1957 17.5L11.2701 12.5745C10.9377 12.242 10.9121 11.7189 11.1934 11.357L11.2701 11.2701Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.cd34d322.svg";
export { ForwardRef as ReactComponent };